import styles from '../styles/navbar.module.css';

function Navbar1({ onCategoryChange }) {
  
  return (
    <div className={styles['nav-container']}>
 <img className={styles['logo']} onClick={() => onCategoryChange('popular')} src="./logo.png" alt='Films 4 u logo' />
    </div>
  );
}

export default Navbar1;
